import styled from "styled-components";
import { SyncOutlined } from "@ant-design/icons";
import { REQUESTED_SK, REJECTED_SK } from "@constants";
import { LOGO } from "@assets";

export const RootContainer = styled.div`
  position: relative;
`;

export const RefreshIcon = styled(SyncOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const Top = styled.div`
  position: relative;
  z-index: 1;

  text-align: center;
  padding-top: 20px;

  .ant-space {
    padding-top: 12px;
    grid-gap: 16px !important;
    margin-right: -48px;
  }

  .ant-btn-dangerous {
    background-color: #ffcfe9;
    color: #000 !important;
  }
`;

export const LightText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ffcfe9;
`;

export const Text = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
`;

export const ActionsWrapper = styled.div`
  padding-top: 37px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
`;

export const Box = styled.div`
  width: 80%;
  padding: 16px 0;
  border-radius: 5px;
  border: 1px solid #e1cce0;
  background-color: #fff;
  filter: drop-shadow(0px 3px 6px #e1cce0);

  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Divider = styled.div`
  width: 1px;
  border-right: 1px solid #e1cce0;
  height: 55px;
`;

export const ActionButton = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  grid-gap: 6px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    font-size: 32px;
  }
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #000;
`;

export const Container = styled.div`
  padding: 24px 16px;
  min-height: calc(100vh - 500px);
`;

export const TitleWrapper = styled.div`
  display: flex;
`;

export const Title = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`;

export const LinkText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #73217d;
  cursor: pointer;
`;

export const ListWrapper = styled.div`
  padding-top: 24px;
  overflow-y: auto;

  > :nth-child(1) {
    padding-top: 0;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 16px 0;
  display: flex;
  grid-gap: 12px;
  align-items: flex-start;
  border-bottom: 1px solid #e1cce0;

  > :nth-child(2) {
    flex: 1;
  }

  > :nth-child(3) {
    text-align: right;
  }
`;

export const ItemText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #820f4e;
  text-transform: capitalize;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: #000000;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const AmountText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #000000;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const StatusText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#AF0000"
      : props.status === REJECTED_SK
      ? "#D69C17"
      : "#09820D"};
  text-transform: capitalize;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const ImageWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(180deg, #73217d, #90348a);
`;

export const LogoImage = styled.img.attrs({
  alt: "img",
  src: LOGO,
})`
  width: 22px;
  border-radius: 50%;
  object-fit: contain;
  align-self: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 32px;
  border-radius: ${(props) => (props.radius === "none" ? "none" : "50%")};
  object-fit: contain;
  align-self: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
`;

export const Bottom = styled.div`
  padding: 0 16px 24px 16px;
`;

export const BottomImage = styled.img.attrs({
  alt: "bottom-img",
})`
  width: 100%;
  object-fit: cover;
  aspect-ratio: 3 / 1;
  border-radius: 5px;
  cursor: pointer;
`;

export const EmptyBox = styled.div`
  text-align: center;
  font-size: 12px;
  color: gray;

  .anticon {
    margin-bottom: 6px;
  }

  svg {
    font-size: 25px;
  }
`;

export const SpinWrapper = styled.div`
  text-align: center;
`;
